import { render, staticRenderFns } from "./chartBilmadim.vue?vue&type=template&id=c6b9f2e8&"
import script from "./chartBilmadim.vue?vue&type=script&lang=js&"
export * from "./chartBilmadim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports